import { render } from "./ApplicationQuestionsView.vue?vue&type=template&id=36dead4b&ts=true"
import script from "./ApplicationQuestionsView.vue?vue&type=script&lang=ts"
export * from "./ApplicationQuestionsView.vue?vue&type=script&lang=ts"

import "./ApplicationQuestionsView.vue?vue&type=style&index=0&id=36dead4b&lang=css"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__